interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  gradient?: string;
}

export default function StatCard({
  title,
  value,
  icon,
  trend,
  gradient = "from-blue-500 to-pink-500",
}: StatCardProps) {
  return (
    <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-soft hover:shadow-medium transition-all duration-300 border border-gray-100">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm text-textLight font-medium mb-1 sm:mb-2">{title}</p>
          <p className="text-2xl sm:text-3xl font-bold text-textDark mb-1 sm:mb-2 truncate">{value}</p>
          {trend && (
            <div className="flex items-center gap-1 flex-wrap">
              <span
                className={`text-xs sm:text-sm font-semibold ${
                  trend.isPositive ? "text-success" : "text-error"
                }`}
              >
                {trend.isPositive ? "↑" : "↓"} {trend.value}
              </span>
              <span className="text-xs text-textLight">จากเดือนที่แล้ว</span>
            </div>
          )}
        </div>
        <div
          className={`w-12 h-12 sm:w-14 sm:h-14 flex-shrink-0 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center text-xl sm:text-2xl shadow-medium`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
